<template>
  <el-dialog
    title="排序设置"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
    center
  >
    <div class="sortWrap" v-loading="loading">
      <div class="sort-table">
        <div class="sort-header">
          <div class="sort-cell sort-index">序号</div>
          <div class="sort-cell">客户</div>
          <div class="sort-cell sort-operate">操作</div>
        </div>
        <draggable
          v-model="sortData"
          handle=".drag-icon"
          animation="150"
          ghost-class="sortable-ghost"
        >
          <div class="sort-row" v-for="(item, index) in sortData" :key="item.id">
            <div class="sort-cell sort-index">{{ index + 1 }}</div>
            <div class="sort-cell">{{ item.member_name || "-" }}</div>
            <div class="sort-cell sort-operate">
              <span class="drag-icon">
                <i class="el-icon-rank"></i>
              </span>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="saveSort">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import draggable from "vuedraggable";
import { postTakeOrderPlacenoSortSave, postTakeOrderPlacenoList } from "@/api/customPit.js";
export default {
  name: "SortDialog",
  components: { draggable },
  props: ["dialogVisible", "supplyTime", "deliveryId"],
  data() {
    return {
      sortData: [],
      loading: false,
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.fetchSortData();
      }
    },
  },
  methods: {
    async fetchSortData() {
      this.loading = true;
      let params = {
        supply_time: this.supplyTime,
        datatype: 2, // 2全部数据
      };
      if (this.deliveryId) {
        params.delivery_id = this.deliveryId;
      }
      try {
        const res = await postTakeOrderPlacenoList(params);
        this.sortData = res.data.list || [];
      } catch (error) {
        console.log(error, "postTakeOrderPlacenoList sort");
      } finally {
        this.loading = false;
      }
    },
    async saveSort() {
      const sortList = this.sortData.map((item, index) => ({
        id: item.id,
        no: index + 1,
      }));
      
      try {
        await postTakeOrderPlacenoSortSave({
          supply_time: this.supplyTime,
          delivery_id: this.deliveryId,
          sort_list: sortList,
        });
        this.$message.success("排序保存成功");
        this.$emit("submit");
        this.handleClose();
      } catch (error) {
        console.log(error, "postTakeOrderPlacenoSortSave");
      }
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.sortWrap {
  height: 400px;
  overflow-y: auto;
  .sort-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
  }
  .sort-header,
  .sort-row {
    display: flex;
  }
  .sort-header {
    color: #333333;
    background: #eff6ff;
    font-weight: 600;
  }
  .sort-row {
    background: #fff;
    &:hover {
      background: #f5f7fa;
    }
  }
  .sort-cell {
    flex: 1;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
  }
  .sort-index {
    flex: 0 0 80px;
  }
  .sort-operate {
    flex: 0 0 180px;
  }
  .drag-icon {
    cursor: move;
    color: #999;
    font-size: 18px;
    display: inline-block;
    padding: 0 12px;
    &:hover {
      color: #13ae67;
    }
  }
  .sortable-ghost {
    opacity: 0.6;
    background: #eff6ff;
  }
}
</style>
